import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { IResponse, IResponsePaginate } from '@/types';
import { Observable } from 'rxjs';

interface Seuil {
  id: {
    ac: any;
    typeMarcher: any;
  };
  seuil: number;
}

interface SeuilDto {
  acId: number;
  typeMarcherId: number;
  seuil: number;
}

@Injectable({
  providedIn: 'root',
})
export class SettingsSeuilsService {
  private httpClient = inject(HttpClient);
  private BASEURL = `${environment.api.paramsUrl}`;

  getSeuils(acId: number): Observable<IResponsePaginate<Seuil>> {
    return this.httpClient.get<IResponsePaginate<Seuil>>(`${this.BASEURL}/ac-seuil/${acId}`);
  }

  addSeuil(seuil: SeuilDto): Observable<IResponse<Seuil>> {
    return this.httpClient.post<IResponse<Seuil>>(`${this.BASEURL}/ac-seuil`, seuil);
  }

  updateSeuil(requestBody: SeuilDto): Observable<IResponse<Seuil>> {
    return this.httpClient.put<IResponse<Seuil>>(`${this.BASEURL}/ac-seuil`, requestBody);
  }
}
